import {useData} from "vike-react/useData";
import {ApiVideo, ApiVideoCategory, ApiVideosData} from "#/src/definitions/ApiDefinitions";
import {VideoCard} from "#/src/components/VideoCard";
import {Sort} from "#/src/utils/sort-utils";
import React, {useEffect, useState} from "react";
import queryString from "query-string";
import {composeHeaders, composeQuery} from "#/src/utils/api-request-utils";
import AppConstants from "#/src/utils/app-constants";
import {AppPageContext, DataWrapped, PaginatedRequest} from "#/src/definitions/AppDefinitions";
import {usePageContext} from "vike-react/usePageContext";
import {LoadableButton} from "#/src/components/LoadableButton";
import styled from "@emotion/styled";

const LoadMoreButton = styled(LoadableButton)`
  min-width: 12em;
`;

export function OldVideos() {
  const [category, setCategory] = useState<string | null>(null);
  const pageContext = usePageContext() as AppPageContext;
  const {data: videosData} = useData() as DataWrapped<ApiVideosData>;
  const oldVideos = Sort.byDate(videosData.oldVideos);
  const [videoData, setVideoData] = useState({error: false, data: oldVideos, page: 1, maxPages: 2});
  useEffect(() => {
    if (typeof window == "undefined") {
      return;
    }
    const query = queryString.parse(window.location.search);
    const queryCategory: string = query.category as string;
    if (queryCategory) {
      onCategoryChange(queryCategory).then(() => {
        setTimeout(() => document.getElementById("old-videos").scrollIntoView(), 150);
      });
    }
  }, [typeof window !== 'undefined' && window.location.search]);

  async function onCategoryChange(category: string | null) {
    let newCategory = category;
    if(category == "") {
      newCategory = null;
    }
    setCategory(newCategory);
    if (newCategory == null) {
      setVideoData({...videoData, data: oldVideos, page: 1, maxPages: 2});
      return;
    }
    setVideoData({...videoData, page: 1, maxPages: 1});
    doFetchVideos(1, category).then(res => {
      setVideoData({...videoData, data: Sort.byDate(res.data), maxPages: res.maxPages, error: false})
    }).catch(() => setVideoData({...videoData, error: true}));
  }

  async function onPageFetch() {
    const nextPage = videoData.page + 1;
    return doFetchVideos(nextPage).then(res => {
      setVideoData({...videoData, page: nextPage});
      setVideoData({...videoData, data: [...videoData.data, ...Sort.byDate(res.data)], page: res.page, maxPages: res.maxPages, error: false})
    }).catch(() => setVideoData({...videoData, error: true}));
  }

  async function doFetchVideos(page, newCategory = category) {
    const query = composeQuery({page, category: newCategory});
    const result = await fetch(`${AppConstants.API_ROUTE}/videos/history?${query}`, {method: "GET", headers: composeHeaders(pageContext)});
    if (result.ok) {
      const pageData = await result.json() as PaginatedRequest<ApiVideo>;
      return Promise.resolve(pageData);
    }
    return Promise.reject();
  }

  function render() {
    return <section className="article-latest" id={"old-videos"}>
      <div className="container-xxl">
        <div className="row">
          <div className="col-xl-12">
            <div className="title-between flex-wrap mb-7">
              <h2 className="basic-headline">
                Starsze filmy
              </h2>
              <div className="flex-list">
                <select className={"form-control"} onChange={(e) => onCategoryChange(e.target.value)} value={category || ""}>
                  <option value={""}>Wszystko</option>
                  {videosData.categories.map((videoCategory: ApiVideoCategory) => {
                    return <option key={videoCategory.id} value={videoCategory.slug}>{videoCategory.name}</option>
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">{renderVideos()}</div>
        {renderFetchButton()}
      </div>
    </section>
  }

  function renderVideos() {
    if (videoData.error) {
      return <div>Błąd!</div>
    }
    return videoData.data.map((video: ApiVideo) => <div key={video.id} className="col-xl-3 col-sm-6 col-md-4"><VideoCard video={video} lazy/></div>);
  }

  function renderFetchButton() {
    if (videoData.maxPages <= videoData.page) {
      return <></>
    }
    return <div className={"row justify-content-center"}>
      <div className={"text-center"}>
        <LoadMoreButton className={"btn btn-secondary"} onClick={onPageFetch}>Załaduj więcej</LoadMoreButton>
      </div>
    </div>
  }

  return render();
}